module.exports = __webpack_public_path__ + "img/img-a2196e6a.b8293b9d.png";